<template>
  <div>
    <epi-offcanvas
      :opening-event-name="openingEventName"
      :title="isSecret ? '비공개일지' : '공개일지'"
    >
      <template v-slot:body>
        <div class="vstack gap-3">
          <wysiwyg v-model="html" :options="wysiwygOptions" />
          <div>
            <input
              type="file"
              class="form-control"
              multiple
              @change="upload"
              accept=".gif,.jpg,.jpeg,.png,.pdf"
            />
            <div class="text-muted">
              파일은 한번에 한 종류로만 선택할 수 있어요
            </div>
          </div>
          <div class="hstack gap-2 flex-wrap">
            <div
              class="d-inline-flex"
              style="width: 100px"
              v-for="i in images"
              :key="i.name"
            >
              <img
                :src="blobToUrl(i)"
                class="img img-thumbnail"
                style="width: 90px"
              />
              <i class="bi bi-x-lg fw-bold" @click="removeImage(i)"></i>
            </div>
          </div>
          <button class="btn btn-primary">작성</button>
        </div>
      </template>
    </epi-offcanvas>
  </div>
</template>
<script>
import { EventName, WysiwygOptions } from "@/const";

export default {
  name: "DiaryAddOffcanvas",
  props: ["isSecret"],
  data() {
    return {
      openingEventName: EventName.DiaryAddOffcanvasOpening,
      html: "",
      images: [],
      pdfs: [],
      wysiwygOptions: WysiwygOptions,
    };
  },
  methods: {
    clearFiles() {
      this.images = [];
      this.pdfs = [];
    },
    removeImage(i) {
      this.images.splice(this.images.indexOf(i), 1);
    },
    upload(e) {
      this.clearFiles();

      const files = Array.from(e.target.files);
      const extensions = files
        .map((a) => a.name.split("."))
        .map((arr) => arr[arr.length - 1]);
      const firstExtension = extensions[0];
      const isPdf = firstExtension === "pdf";
      if (isPdf) {
        if (!extensions.every((a) => a === "pdf")) {
          alert("파일은 한번에 한 종류로만 선택할 수 있어요");
        } else {
          this.pdfs = files;
        }
      } else {
        if (!extensions.every((a) => a !== "pdf")) {
          alert("파일은 한번에 한 종류로만 선택할 수 있어요");
        } else {
          this.images = files;
        }
      }
    },
    blobToUrl(a) {
      return URL.createObjectURL(a);
    },
  },
};
</script>
